module.exports = __webpack_public_path__ + "background-nav.png?bfd61a5955623176b0f80dc5f4764440";